"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyBoxWithPlanSelector = void 0;
const react_1 = __importStar(require("react"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const purchase_1 = require("@amzn/monera-app-core/lib/services/actions/purchase");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const shopping_portal_1 = require("@amzn/monera-app-core/lib/utils/shopping-portal");
const utils_1 = require("../../utils");
const apx_payments_portal_widget_1 = require("../apx-payments-portal-widget");
const one_click_purchase_button_1 = require("../one-click-purchase-button");
const types_1 = require("../one-click-purchase-button/types");
const page_wrapper_1 = require("../page-wrapper");
const plan_selector_1 = require("../plan-selector");
const terms_and_conditions_1 = require("../terms-and-conditions");
const styles_1 = require("./styles");
const BUY_BOX_WITH_PLAN_SELECTOR_ID = 'BuyBoxWithPlanSelector';
const BuyBoxWithPlanSelector = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const [selectedPlanIndex, setSelectedPlanIndex] = (0, react_1.useState)((_a = props.activePlanIndex) !== null && _a !== void 0 ? _a : props.defaultSelectedPlanIndex);
    const [isTermsAccepted, setIsTermsAccepted] = (0, react_1.useState)(false);
    const [termsAndConditionsErrorMessage, setTermsAndConditionsErrorMessage] = (0, react_1.useState)();
    const [selectedPaymentIntrumentId, setSelectedPaymentIntrumentId] = (0, react_1.useState)();
    const [paymentSelectWidgetErrorMessage, setPaymentSelectWidgetErrorMessage] = (0, react_1.useState)();
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [shoppingPortalState] = (0, monera_app_core_1.useShoppingPortalStore)();
    const platformType = (0, shopping_portal_1.getPlatformType)(shoppingPortalState.deviceAttributes);
    const isIosMshop = (0, utils_1.isIOS)(platformType) && (0, utils_1.isMshop)(deviceType);
    const handlePlanSelect = (0, react_1.useCallback)((index) => {
        setSelectedPlanIndex(index);
        setIsTermsAccepted(false);
    }, []);
    const handleTermsChange = (0, react_1.useCallback)((accepted) => {
        setIsTermsAccepted(accepted);
        setTermsAndConditionsErrorMessage('');
    }, []);
    const termsAndConditionsRef = (0, react_1.useRef)(null);
    const validate = (0, react_1.useCallback)(() => {
        var _a, _b;
        const isError = !isTermsAccepted || !selectedPaymentIntrumentId || selectedPlanIndex === props.activePlanIndex;
        if (isError) {
            const methodName = 'validate';
            if (!isTermsAccepted) {
                setTermsAndConditionsErrorMessage(props.termsAndConditionsErrorMessage);
                (_b = (_a = termsAndConditionsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, { block: 'center' });
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName: 'purchaseClickedWithoutTermsAccepted',
                    success: false,
                    fault: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.warn('Purchase attempted without accepting terms and conditions', {
                    selectedPlanIndex,
                    requestId: configStoreState.requestId
                });
            }
            if (!selectedPaymentIntrumentId) {
                setPaymentSelectWidgetErrorMessage(props.paymentSelectWidgetErrorMessage);
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName: 'purchaseClickedWithoutPaymentMethod',
                    success: false,
                    fault: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.warn('Purchase attempted without selecting payment method', {
                    selectedPlanIndex,
                    requestId: configStoreState.requestId
                });
            }
        }
        return !isError;
    }, [
        isTermsAccepted,
        selectedPlanIndex,
        selectedPaymentIntrumentId,
        props.activePlanIndex,
        props.termsAndConditionsErrorMessage,
        props.paymentSelectWidgetErrorMessage,
        configStoreState.requestId
    ]);
    const selectedPlan = props.availablePlanOptions[selectedPlanIndex || 0];
    const selectedTermsAndConditionsMessage = props.termsAndConditionsMessages[selectedPlanIndex || 0];
    const selectedTermsAndConditionsDescription = props.termsAndConditionsDescriptions
        ? props.termsAndConditionsDescriptions[selectedPlanIndex || 0]
        : undefined;
    const autoRenewMessage = props.autoRenewMessages[selectedPlanIndex || 0];
    const selectedDiscountedUpsellMessage = (_b = props.discountedUpsellMessages) === null || _b === void 0 ? void 0 : _b[selectedPlanIndex || 0];
    const defaultHandlePurchaseResult = (response) => {
        var _a, _b;
        const methodName = 'defaultHandlePurchaseResult';
        const metricName = 'handlePurchaseResult';
        const isSuccess = response.type === types_1.PurchaseButtonResponseType.SUCCESS;
        monera_app_core_1.LOGGER[isSuccess ? 'info' : 'error']('Response from purchase action: ', response);
        (0, metric_helper_1.meterFatals)({
            methodName,
            metricName,
            success: isSuccess,
            fault: !isSuccess,
            requestId: configStoreState.requestId
        });
        if (isSuccess) {
            redirectToUrl((_a = props.successRedirectUrl) !== null && _a !== void 0 ? _a : `${window.location.origin}/thank-you?orderId=${(_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.orderId}`);
        }
        else {
            (0, monera_app_core_1.showDoggyPageClientSide)();
        }
    };
    const buttonContainerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (!props.stickyMobileCtaButton) {
            return;
        }
        const scrollContainer = (_b = (_a = buttonContainerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.offsetParent;
        const buttonContainerHeight = (_c = buttonContainerRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight;
        if (scrollContainer && buttonContainerHeight) {
            const container = scrollContainer;
            container.style.paddingBottom = `${buttonContainerHeight}px`;
            if (isIosMshop) {
                const windowHeight = window.innerHeight;
                let timeoutId = null;
                const bounceBackIfTooLow = () => {
                    if (timeoutId !== null) {
                        clearTimeout(timeoutId);
                    }
                    timeoutId = window.setTimeout(() => {
                        const scrollTop = window.scrollY;
                        const docHeight = document.documentElement.scrollHeight;
                        const pageBottom = docHeight - windowHeight;
                        const distanceToBottom = docHeight - (scrollTop + windowHeight);
                        if (distanceToBottom <= 0) {
                            window.scrollTo({ top: pageBottom, behavior: 'smooth' });
                        }
                    }, 100);
                };
                window.addEventListener('scroll', bounceBackIfTooLow);
                return () => {
                    window.removeEventListener('scroll', bounceBackIfTooLow);
                    if (timeoutId !== null) {
                        clearTimeout(timeoutId);
                    }
                };
            }
        }
        return;
    }, [props.stickyMobileCtaButton]);
    return (react_1.default.createElement(styles_1.Container, { id: BUY_BOX_WITH_PLAN_SELECTOR_ID },
        react_1.default.createElement(plan_selector_1.PlanSelector, Object.assign({}, props, { selectedPlanIndex: selectedPlanIndex, onSelect: handlePlanSelect })),
        selectedPlan && autoRenewMessage && (react_1.default.createElement(styles_1.AutoRenewMessageWrapper, null,
            react_1.default.createElement(styles_1.AutoRenewMessage, null, autoRenewMessage))),
        props.paymentsPortalWidget && (react_1.default.createElement(styles_1.PaymentMethodsWidgetContainer, null,
            react_1.default.createElement(apx_payments_portal_widget_1.ApxPaymentsPortalWidget, { html: (_c = props.paymentsPortalWidget) === null || _c === void 0 ? void 0 : _c.html, missingPaymentInstrumentText: (_d = props.paymentsPortalWidget) === null || _d === void 0 ? void 0 : _d.missingPaymentInstrumentText, selectPaymentPreferencePageUrl: (_e = props.paymentsPortalWidget) === null || _e === void 0 ? void 0 : _e.selectPaymentPreferencePageUrl, selectPaymentPreferencePageLinkText: (_f = props.paymentsPortalWidget) === null || _f === void 0 ? void 0 : _f.selectPaymentPreferencePageLinkText, error: paymentSelectWidgetErrorMessage, title: (_g = props.paymentsPortalWidget) === null || _g === void 0 ? void 0 : _g.title, doNotModifyApxHtml: (_h = props.paymentsPortalWidget) === null || _h === void 0 ? void 0 : _h.doNotModifyApxHtml, onSelectInstrumentIdCallback: setSelectedPaymentIntrumentId }))),
        react_1.default.createElement(terms_and_conditions_1.TermsAndConditions, { containerRef: termsAndConditionsRef, text: selectedTermsAndConditionsMessage, description: selectedTermsAndConditionsDescription, isChecked: isTermsAccepted, error: termsAndConditionsErrorMessage, onChange: handleTermsChange }),
        selectedDiscountedUpsellMessage && (react_1.default.createElement(styles_1.DiscountedUpsellMessage, null, (0, html_react_parser_1.default)(selectedDiscountedUpsellMessage))),
        react_1.default.createElement(styles_1.ButtonContainer, { sticky: props.stickyMobileCtaButton && (0, utils_1.isMobile)(deviceType), deviceType: deviceType, platformType: platformType, ref: buttonContainerRef },
            react_1.default.createElement(one_click_purchase_button_1.OneClickPurchaseButton, { deviceType: deviceType, paymentMethodId: selectedPaymentIntrumentId, purchaseContext: selectedPlan, callback: (_j = props.handlePurchaseResult) !== null && _j !== void 0 ? _j : defaultHandlePurchaseResult, purchaseAction: (_k = props.purchaseAction) !== null && _k !== void 0 ? _k : purchase_1.purchaseAction, text: props.ctaButtonLabel, "data-testid": "one-click-purchase-button", validateCallback: validate }))));
};
exports.BuyBoxWithPlanSelector = BuyBoxWithPlanSelector;
const redirectToUrl = (url) => {
    window.location.href = url;
};
